export default __webpack_public_path__ + "static/media/close.7285860b.svg";